import { Box, Typography } from "@mui/material";
import { memo } from "react";

import type { PageHeaderProps } from "./PageHeader.types";
import * as styles from "./PageHeader.styles";

export type { PageHeaderProps } from "./PageHeader.types";

export const PageHeader = memo(function PageHeader({ title, subtitle, action }: PageHeaderProps) {
  return (
    <Box sx={styles.root}>
      <Box sx={styles.textBlock}>
        <Typography component="h1" sx={styles.title}>
          {title}
        </Typography>
        {subtitle ? (
          <Typography component="p" sx={styles.subtitle}>
            {subtitle}
          </Typography>
        ) : null}
      </Box>
      {action ?? null}
    </Box>
  );
});
